module.exports = __webpack_public_path__ + "img/09e8bf1278905476f9f77e1aca259da4.png";